import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b3ba796"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "RolesListItem" }
const _hoisted_2 = { class: "text-base font-semibold" }
const _hoisted_3 = { class: "mt-3 flex items-center justify-end" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye mr-2" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pen mr-2" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_button = _resolveComponent("the-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, "(ID: " + _toDisplayString(_ctx.item.id) + ") " + _toDisplayString(_ctx.item.name), 1),
    _createElementVNode("p", null, "Описание: " + _toDisplayString(_ctx.item.description), 1),
    _createElementVNode("p", null, "Доступов: " + _toDisplayString(_ctx.item.permissions.length), 1),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_the_button, {
        class: "primary small text mr-2",
        onClick: _ctx.emitOpenPermissions
      }, {
        default: _withCtx(() => [
          _hoisted_4,
          _createTextVNode(" Список доступов ")
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_the_button, {
        class: "primary small text mr-2",
        onClick: _ctx.emitUpdate
      }, {
        default: _withCtx(() => [
          _hoisted_5,
          _createTextVNode(" Редактировать ")
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_the_button, {
        class: "red small text",
        onClick: _ctx.emitDelete
      }, {
        default: _withCtx(() => [
          _hoisted_6,
          _createTextVNode(" Удалить ")
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
}